const autoNgTemplateLoaderTemplate1 = require('./createResourcePool.html');

angular.module('portainer.kubernetes').component('kubernetesCreateResourcePoolView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesCreateResourcePoolController',
  controllerAs: 'ctrl',
});
